@if (rowHeaderColumns && itemColumns) {
  <table class="[ table border-all row-h-s ]">
    <thead>
      <tr class="[ surface text-left ]">
        @for (columnHeader of rowHeaderColumns; track columnHeader; let first = $first; let last = $last) {
          <th data-cy="check-box-table-head-column-header" data-type="row" [class.corner-top-is-m]="first">{{ columnHeader.caption }}</th>
        }
        @for (columnHeader of itemColumns; track trackByItemColumns($index, columnHeader); let last = $last) {
          <th data-cy="check-box-table-head-column-header" data-type="item" class="text-center" [class.corner-top-right-m]="last">
            {{ columnHeader.item[columnHeader.label] }}
          </th>
        }
      </tr>
      @if (selectAllForColumnEnabled) {
        <tr data-cy="check-box-table-head-row-select-all" class="[ surface text-left ]">
          <th [colSpan]="rowHeaderColumns.length">Alle</th>
          @for (itemColumn of itemColumns; track trackByItemColumns($index, itemColumn)) {
            <th class="text-center" data-cy="check-box-table-head-column-header">
              <dcr-checkbox
                data-cy="check-box-table-select-all"
                #selectAllForColumnToggle
                campusClickPreventDefault
                (click)="clickSelectAllForColumn($event, itemColumn, itemColumn.isAllSelected)"
                [checked]="itemColumn.isAllSelected"
              ></dcr-checkbox>
            </th>
          }
        </tr>
      }
    </thead>
    <tbody>
      @if (subLevels) {
        @for (subLevel of subLevels; track trackBySubLevel($index, subLevel)) {
          <tr
            data-cy="check-box-table-body-row"
            data-type="sublevel"
            [ngClass]="subLevel.isHighlighted ? ['primary-container', 'border', 'border-2', 'border-primary'] : ['surface-container']"
          >
            <td data-cy="check-box-table-body-column-header" data-type="row" [colSpan]="rowHeaderColumns.length">
              <span class="[ title-small ]">
                <ng-container
                  *ngTemplateOutlet="
                    row || defaultRowTemplate;
                    context: { $implicit: { label: subLevel.item[subLevel.label], data: subLevel } }
                  "
                ></ng-container>
              </span>
            </td>
            @for (itemHeader of itemColumns; track trackByItemColumns($index, itemHeader)) {
              <td class="text-center" data-cy="check-box-table-body-column-header" data-type="item">
                @if (selectAllForSubLevelEnabled) {
                  <dcr-checkbox
                    data-cy="check-box-table-body-header-select-item"
                    #subLevelToggle
                    campusClickPreventDefault
                    (click)="clickSubLevelToggle($event, subLevel, itemHeader, itemHeader.isAllSelected)"
                    [disabled]="itemHeader.isAllSelected"
                    [checked]="itemHeader.isAllSelected || subLevel.content[itemHeader.item[itemHeader.key]]"
                  ></dcr-checkbox>
                }
              </td>
            }
          </tr>
          <ng-container
            *ngTemplateOutlet="
              itemRows;
              context: {
                subLevel: subLevel,
                items: subLevel.children,
                rowHeaderColumns: rowHeaderColumns,
                itemColumns: itemColumns,
              }
            "
          ></ng-container>
        }
      }
      @if (items) {
        <ng-container
          *ngTemplateOutlet="
            itemRows;
            context: {
              subLevel: { content: {} },
              items: items,
              rowHeaderColumns: rowHeaderColumns,
              itemColumns: itemColumns,
            }
          "
        ></ng-container>
      }
      <ng-template
        #itemRows
        let-subLevel="subLevel"
        let-items="items"
        let-rowHeaderColumns="rowHeaderColumns"
        let-itemColumns="itemColumns"
      >
        @for (item of items; track trackByItems($index, item); let even = $even; let lastRow = $last) {
          <tr
            data-cy="check-box-table-body-row"
            data-type="item"
            [ngClass]="
              item.isHighlighted
                ? ['primary-container', 'border', 'border-2', 'border-primary']
                : even
                  ? ['surface']
                  : ['surface-container-lowest']
            "
          >
            @for (rowHeaderColumn of rowHeaderColumns; track trackByRowHeaderColumns($index, rowHeaderColumn); let first = $first) {
              <td data-cy="check-box-table-body-data-header">
                <ng-container
                  *ngTemplateOutlet="
                    row || defaultRowTemplate;
                    context: { $implicit: { label: item.header[rowHeaderColumn.key], data: item } }
                  "
                ></ng-container>
              </td>
            }
            @for (itemColumn of itemColumns; track trackByItemColumns($index, itemColumn); let last = $last) {
              <td class="text-center" data-cy="check-box-table-body-data-item">
                <dcr-checkbox
                  data-cy="check-box-table-body-data-select-item"
                  #slideToggle
                  [attr.checked]="
                    item.content[itemColumn.item[itemColumn.key]] ||
                    subLevel.content[itemColumn.item[itemColumn.key]] ||
                    itemColumn.isAllSelected ||
                    null
                  "
                  campusClickPreventDefault
                  (click)="
                    clickToggle(
                      $event,
                      item.header,
                      itemColumn.item,
                      subLevel.item,
                      subLevel.content[itemColumn.item[itemColumn.key]],
                      itemColumn.isAllSelected
                    )
                  "
                  [disabled]="itemColumn.isAllSelected || subLevel.content[itemColumn.item[itemColumn.key]]"
                ></dcr-checkbox>
              </td>
            }
          </tr>
        }
      </ng-template>
      <ng-template #defaultRowTemplate let-data>
        {{ data.label }}
      </ng-template>
    </tbody>
  </table>
}
